var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forward-guide-inner"},[_c('img',{staticClass:"guide-image",attrs:{"src":require("../assets/images/webhook-guide.png")}})])
}]

export { render, staticRenderFns }